import { PageHeaderComponent } from 'app/components/page-header/PageHeaderComponent'
import { Tabs, TabsList, TabsTrigger } from 'app/components/ui/tabs'
import type { GroupBy } from 'app/components/viz/DateGroupSelector'
import type { WorkspaceItem } from './useCarestackDashboard'

const COLORS = [`#2077b4`, `#ff7f0f`, `#2da02c`]
const GROUP_OPTIONS: GroupBy[] = [`days`, `weeks`, `months`]

export type CarestackDashboardShadcnComponentProps = {
  base64: string
  workspaces: WorkspaceItem[]
  groupBy: GroupBy
  onGroupChange: (group: GroupBy) => void
}

export function CarestackDashboardShadcnComponent({
  base64,
  workspaces,
  groupBy,
  onGroupChange,
}: CarestackDashboardShadcnComponentProps) {
  return (
    <div className="flex h-full max-w-[1600px] flex-col overflow-hidden">
      <PageHeaderComponent
        className="grow-0"
        title="Carestack Requests"
        primaryButtonSlot={
          <div className="flex items-center gap-2">
            <span className="text-ui-xs text-default">Aggregated by:</span>
            <Tabs value={groupBy} onValueChange={(v) => onGroupChange(v as GroupBy)}>
              <TabsList>
                {GROUP_OPTIONS.map((opt) => (
                  <TabsTrigger key={opt} value={opt} className="capitalize">
                    {opt}
                  </TabsTrigger>
                ))}
              </TabsList>
            </Tabs>
          </div>
        }
      />
      <div className="flex">
        <div className="grow overflow-auto">
          <img src={`data:image/png;base64,${base64}`} alt="Carestack requests chart" />
        </div>
        <div className="flex flex-col gap-1 p-2">
          {workspaces.map((workspace, i) => (
            <div key={workspace.workspaceId} className="flex items-center gap-1 text-sm">
              <span className="text-subtle">{workspace.workspaceId}</span>
              <span>-</span>
              <span className="font-bold" style={{ color: COLORS[i % COLORS.length] }}>
                {workspace.workspaceName}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
